import {Button, DataStatus, showNotification} from 'platform/components';
import {Center, Show, VStack} from 'platform/foundation';

import {isNotNil} from 'ramda';

import i18n from '@dms/i18n';
import {dashboardRoutes, myProfileRoutes} from '@dms/routes';
import {CommonSkeleton} from '@dms/shared';

import {useNavigate, useOnMount, useQueryState} from 'shared/web';

export function UserMailboxOAuthFinish() {
  const [error] = useQueryState('error');
  const navigate = useNavigate();

  const isError = isNotNil(error);

  useOnMount(() => {
    if (isError) {
      return;
    }
    showNotification.success(i18n.t('page.myProfile.receivingMailbox.notifications.connected'));
    navigate(myProfileRoutes.emailSynchronization);
  });

  return (
    <Center width="100%" height="100%">
      <VStack spacing={4}>
        <DataStatus
          isError={isError}
          errorMessage={i18n.t('page.myProfile.receivingMailbox.notifications.connectFailed')}
        >
          <CommonSkeleton />
        </DataStatus>

        <Show when={isError}>
          <Center>
            <Button
              leftIcon="action/arrow_right_alt"
              title={i18n.t('page.homepage.labels.title')}
              onClick={() => navigate(dashboardRoutes.home)}
            />
          </Center>
        </Show>
      </VStack>
    </Center>
  );
}
